module.exports = __webpack_public_path__ + "img/notificaciones_bg.ec771790.png";